import VueI18n, { LocaleMessages } from 'vue-i18n'

export enum LoginStates {
    login = 'login',
    signUp = 'signUp',
    forgotPassword = 'forgotPassword'
}

export enum ConnectionStates {
    idle = '',
    connecting = 'connecting',
    authFail = 'authFail',
    authorized = 'authorized',
    error = 'error'
}

export enum VerifyEmailStates {
    verifying = 'verifying',
    verified = 'verified',
    error = 'error'
}

export interface LocaleOverview {
    locale: string,
    name: string,
    icon: string,
    settings: {
        fonts: [],
        ltr: boolean
    }
}

export interface WhiteLabel {
    label: string
    appTitle: string
    logoImg: string,
    favIcon: string,
    url: string,
    copyright?: string,
    bg?: string,
    bgColor?: string,
    logoImgSub?: string
}

export interface VueI18nExtended extends VueI18n { whitelabel: WhiteLabel, localeOverview: LocaleOverview[] }
